// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"38":"MainScreen","253":"EndCallScreen","415":"VideoCallScreen","436":"TestScreen","988":"BeginCallScreen"}[chunkId] + "." + {"38":"101d5528","253":"ea47e6bc","415":"76a20ff7","436":"11ca12e2","988":"40300eff"}[chunkId] + ".chunk.css";
};